// Inspection URLs are compared by Google exactly, including a final slash.
// https://example.com/page and https://example.com/page/ are different URLs.
// Do not run these strings through the URL parser: it resolves "." and ".."
// and drops that slash for some paths.

const edgeSpace = /^[ \t\u00a0\r]+|[ \t\u00a0\r]+$/g;

/** Trim space around one URL without touching slashes. */
export function exactUserUrl(value: string | undefined | null): string {
  return (value || "").replace(edgeSpace, "");
}

/**
 * One URL per line, in the order entered. Blank lines are skipped.
 * Slashes, queries, fragments, and dot segments stay as typed.
 */
export function inspectionUrlsForApi(text: string): string {
  const lines: string[] = [];
  for (const rawLine of (text || "").split("\n")) {
    const line = exactUserUrl(rawLine);
    if (line !== "") {
      lines.push(line);
    }
  }
  return lines.join("\n");
}
